export const REFLECTION_QUESTIONS = [
  {
    id: 'what_learned',
    question: 'What did you learn today?',
    type: 'textarea',
    placeholder: 'Describe the key concepts or skills you learned...',
    required: true,
    rows: 3,
  },
  {
    id: 'most_challenging',
    question: 'What was the most challenging concept?',
    type: 'textarea',
    placeholder: 'What did you struggle with?',
    required: false,
    rows: 2,
  },
  {
    id: 'aha_moment',
    question: 'What was your biggest breakthrough or "aha" moment?',
    type: 'textarea',
    placeholder: 'Describe any sudden insights or realizations...',
    required: false,
    rows: 2,
  },
  {
    id: 'experience_connection',
    question: 'How did your experiences today relate to what you are learning?',
    type: 'textarea',
    placeholder:
      'Connect your daily experiences, observations, or interactions with the concepts you studied...',
    required: false,
    rows: 3,
  },
  {
    id: 'application',
    question: 'How will you apply what you learned?',
    type: 'textarea',
    placeholder: 'How can you use this knowledge in practice?',
    required: false,
    rows: 2,
  },
  {
    id: 'questions',
    question: 'What questions do you still have?',
    type: 'textarea',
    placeholder: 'What are you still curious about?',
    required: false,
    rows: 2,
  },
  {
    id: 'understanding_rating',
    question: 'Rate your understanding',
    type: 'slider',
    min: 1,
    max: 5,
    required: true,
  },
  {
    id: 'engagement_rating',
    question: 'Rate your engagement',
    type: 'slider',
    min: 1,
    max: 5,
    required: true,
  },
];
